import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { PurchaseOrders } from "app/_models/purchaseOrders/purchase-orders";
import { UserModel } from "app/_models/user-model";
import { CrudPurchaseOrderService } from "app/_services/MasterCrudOps/crud-purchase-order.service";
import { AddPurchaseOrderComponent } from "../add-purchase-order/add-purchase-order.component";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { UiActionUtils } from "app/shared/utils/ui-action-utils";
import { EditPurchaseOrderComponent } from "../edit-purchase-order/edit-purchase-order.component";
import * as XLSX from "xlsx";
import { AddChildPurchaseOrderComponent } from "../add-child-purchase-order/add-child-purchase-order.component";
import { AddMoreOrderDetailsComponent } from "../podetails/add-more-order-details/add-more-order-details.component";
declare const swal: any;

@Component({
  selector: "app-list-purchase-order",
  templateUrl: "./list-purchase-order.component.html",
  styleUrls: ["./list-purchase-order.component.css"],
})
export class ListPurchaseOrderComponent implements AfterViewInit {
  isLoaderResult = true;
  resultLength = 0;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  poNumber: string;
  pageSizeOptions: number[] = [25, 50, 75, 100];
  isAdminGroupUser: boolean = false;
  purchaseOrders: PurchaseOrders[] = [];
  resultDetails: PurchaseOrders[] = [];
   totalresultDetails: PurchaseOrders[] = [];
  editPurchaseOrder:PurchaseOrders;
  deletePurchaseOrder:PurchaseOrders;
  currentUser: UserModel;
  displayedColumns: string[] = [
    "poNumber",
    "parentPo",
    "orderDetailsCount",
    "orderDate",
    "vendorCode",
    "address",
    "description",
    "createdBy",
    "createdOn",
    "updatedBy",
    "updatedOn",
    "orderQuantity",
    "receivedQuantity",
    "updateRemarks",
    "addChild",
    "addMore",
    "edit",
    "delete"
  ];
  allColumns = [
    { name: "poNumber", label: "Po Number" },
     { name: "parentPo", label: "Parent Po" },
    { name: "orderDetailsCount", label: "PO-Details" },
    { name: "orderDate", label: "Order Date" },
    { name: "vendorCode", label: "Vendor" },
    { name: "address", label: "Address" },
    { name: "description", label: "Description" },
    { name: "createdBy", label: "Created By" },
    { name: "createdOn", label: "Created On" },
    { name: "updatedBy", label: "Updated By" },
    { name: "updatedOn", label: "Updated On" },
    { name: "orderQuantity", label: "Order Qty" },
    { name: "receivedQuantity", label: "Rx Qty" },
    { name: "updateRemarks", label: "Update Remarks" },
    {name:"addChild", label:"Add Child"},
    {name:"addMore", label:"Add More"},
    {name:'edit', label:"Edit"},
    {name:"delete", label: "Delete"}
    
  ];

  defaultColumns = [
    "poNumber",
    "orderDetailsCount",
    "orderDate",
    "orderQuantity",
    "receivedQuantity",
    "edit",
    "delete"
  ];

  dataSource = new MatTableDataSource<PurchaseOrders>([]);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private readonly datepipe: DatePipe,
    private readonly crudPoService: CrudPurchaseOrderService,
    private readonly matDialog: MatDialog,
    private readonly router: Router
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  ngAfterViewInit() {
    const saved = localStorage.getItem("findiPoDisplayedColumns");
    this.displayedColumns = saved
      ? JSON.parse(saved)
      : [...this.defaultColumns];
    this.dataSource.paginator = this.paginator;
    this.loadData();
  }

  loadData() {
    this.poNumber = "";
    this.isLoaderResult = false;
    this.getAllPurchaseOrders(
      this.paginator.pageIndex + 1,
      this.paginator.pageSize,
      ""
    );
  }

  getAllPurchaseOrders(
    pageNumber: number,
    pageSize: number,
    searchPoNumber: string
  ) {
    this.isLoaderResult = true;

    const model = {
      currentPage: pageNumber ?? 1,
      pageSize: pageSize ?? 25,
      downloadAllData: false,
      poNumber: searchPoNumber,
    };

    this.crudPoService.getAllPurchaseOrders(model).subscribe((data) => {
      this.isLoaderResult = false;

      if (!data.didError) {
        const results = data.model || [];
        if(results.length == 0)
        {
           swal({
            title: "",
            text: data.message + "\n" + data.additionalMessage,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }

        this.purchaseOrders = results;
        this.resultDetails = results;

        this.dataSource = new MatTableDataSource<PurchaseOrders>(results);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        // ✅ Add this block to make filter work on formatted fields
        this.dataSource.filterPredicate = (
          data: PurchaseOrders,
          filter: string
        ): boolean => {
          const formatDate = (dateStr: any): string => {
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return "";
            return (
              this.datepipe.transform(date, "dd-MMM-yyyy")?.toLowerCase() ?? ""
            );
          };

          const searchText = filter.trim().toLowerCase();
          const formattedOrderDate = formatDate(data.orderDate);
          const formattedCreatedOn = formatDate(data.createdOn);
          const formattedUpdatedOn = formatDate(data.updatedOn);

          const dataString = `
                            ${data.poNumber} ${data.orderDetailsCount}
                            ${formattedOrderDate} ${formattedCreatedOn} ${formattedUpdatedOn}
                            ${data.vendorCode} ${data.address} ${data.description}
                            ${data.createdBy} ${data.updatedBy} ${data.updateRemarks}
                            ${data.orderQuantity} ${data.receivedQuantity} ${data.isDeleted}
                          `.toLowerCase();

          return dataString.includes(searchText);
        };

        this.totalRows = data.totalRecords;
        this.resultLength = results.length;

        if (results.length === 0) {
          this.dataSource.data = [];
          this.paginator.length = 0;
        }
      } else {
        this.dataSource.data = [];
        this.totalRows = 0;
        this.resultLength = 0;
        swal({
          title: "",
          text: data.message,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    });
  }

  navigateToAddPo() {
    const dialogRef = this.matDialog.open(AddPurchaseOrderComponent, {
      width: "80%",
      height: "98%",
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAllPurchaseOrders(1, this.pageSize, "");
        setTimeout(() => {}, 1500);
      }
    });
  }

  onColumnChange() {
    localStorage.setItem(
      "findiPoDisplayedColumns",
      JSON.stringify(this.displayedColumns)
    );
  }

  toggleColumn(column: string, checked: boolean) {
    if (checked && !this.displayedColumns.includes(column)) {
      this.displayedColumns.push(column);
    } else {
      this.displayedColumns = this.displayedColumns.filter((c) => c !== column);
    }
    this.onColumnChange();
  }

  
  searchByPoNumber(searchValue: string)
  {
    if (searchValue.length == 0) {
      swal({
        title: "",
        text: "Please enter Po number.",
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
    } else {
    this.poNumber = searchValue;
    this.paginator.pageIndex = 0;
    this.currentPage = 0;
    this.getAllPurchaseOrders(1, this.pageSize, this.poNumber);
    }
  }

  onClearSearch()
  {
     this.paginator.pageIndex = 0;
    this.currentPage = 0;
    this.getAllPurchaseOrders(1, this.pageSize, '');
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getAllPurchaseOrders(
      this.currentPage + 1,
      this.pageSize,
      this.poNumber
    );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue;
  }

showOrderDetails(e, element)
{
   this.router.navigateByUrl("/poDetail", {
      state: {
        findiPurchaseOrderId: element.findiPurchaseOrderId,
        pageNumber: this.paginator.pageIndex + 1,
        pageSize: this.paginator.pageSize,
        poNumber:element.poNumber
      },
    });
}

addChildDetails(any, element:any): void {
    this.editPurchaseOrder = element ;//deep copy
    const dialogRef = this.matDialog.open(AddChildPurchaseOrderComponent, {
      width: "80%",
      height: "98%",
      disableClose: true,
      data: {poDetail:this.editPurchaseOrder,   pageNumber: this.paginator.pageIndex + 1, pageSize: this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
       this.getAllPurchaseOrders(result.pageNumber, result.pageSize, this.poNumber);
    });
  }

  addMoreDetails(any, element:any): void {
    this.editPurchaseOrder = element ;//deep copy
    const dialogRef = this.matDialog.open(AddMoreOrderDetailsComponent, {
      width: "98%",
      height: "75%",
      disableClose: true,
      data: {poDetail:this.editPurchaseOrder,   pageNumber: this.paginator.pageIndex + 1, pageSize: this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
       this.getAllPurchaseOrders(result.pageNumber, result.pageSize, this.poNumber);
    });
  }

  updatePurchaseOrder(e:any, element:any): void {
    this.editPurchaseOrder = element ;//deep copy
    const dialogRef = this.matDialog.open(EditPurchaseOrderComponent, {
      width: "75%",
      height: "50%",
      disableClose: true,
      data: {editPoOrder:this.editPurchaseOrder,   pageNumber: this.paginator.pageIndex + 1, pageSize: this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
       this.getAllPurchaseOrders(result.pageNumber, result.pageSize, this.poNumber);
    });
  }

  softDelete(e: any, element: any): void {
  UiActionUtils.confirmWithRemarks("You won't be able to revert this!", (remarks: string) => {
    this.deletePurchaseOrderDetail(e, element, remarks);
  });
}

  deletePurchaseOrderDetail(e:any, element:any, remarks: string): void {
   
    this.deletePurchaseOrder = JSON.parse(JSON.stringify(element)) ;//deep copy
      this.isLoaderResult = true;
 const model = {
    requestId: element.findiPurchaseOrderId,   
    remarks: remarks
  };
 this.crudPoService.deletePurchaseOrder(model).subscribe(
      data => {
        if (data.didError) {
          UiActionUtils.showError(data.message, data.additionalMessage);
        } else {
          UiActionUtils.showSuccess(data.message);
           this.getAllPurchaseOrders(this.paginator.pageIndex + 1, this.paginator.pageSize, '');
        }
        this.isLoaderResult = false;
      },
      err => {
        UiActionUtils.showError('Something went wrong', err.message);
        this.isLoaderResult = false;
      }
    );
     
  }

    downloadAllRecords() {
    swal({
      title: "Are you sure to do this?",
      text: "This process does not display data. It will download all records in a spreadsheet.",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Download the records.",
    }).then((result) => {
      if (result === true) {
        this.isLoaderResult = true;
        let model = {
          currentPage: 0,
          pageSize: 0,
          downloadAllData: true,
          poNumber:""
        };
        this.crudPoService.getAllPurchaseOrders(model).subscribe(
          (results) => {
            this.isLoaderResult = false;
            if (!results.didError) {
              this.totalresultDetails = results.model;
              const workSheet = XLSX.utils.json_to_sheet(
                this.totalresultDetails.map((item) => {
                  return {
                      PoNumber: item.poNumber,
                      ParentPo:item.parentPo,
                      Description:item.description,
                      VendorCode: item.vendorCode,
                      OrderDate: this.datepipe.transform(item.orderDate,"dd-MMM-yyyy"),
                      OrderQuantity: item.orderQuantity,
                      ReceivedQuantity: item.receivedQuantity,
                      createdBy:item.createdBy,
                      CreatedOn: this.datepipe.transform(item.createdOn,"dd-MMM-yyyy HH:mm:ss"),
                      UpdatedBy:item.updatedBy,
                      UpdatedOn: this.datepipe.transform(item.updatedOn,"dd-MMM-yyyy HH:mm:ss"),
                      AssetCreated:item.isAssetCreated, 
                      Address: item.address
                  };
                })
              );
              const workBook: XLSX.WorkBook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
              let fileName =
                "PurchaseOrder_" +
                this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
                ".xlsx";
              XLSX.writeFile(workBook, fileName);
            } else {
              this.isLoaderResult = false;
              swal({
                title: "",
                text: results.message,
                type: "error",
                confirmButtonClass: "btn btn-info",
              });
            }
          },
          (error) => {
            this.isLoaderResult = false;
            swal({
              title: "",
              text: "Somthing went wrong. Please contact admin",
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          }
        );
      }
    });
  }
  

}
